import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {TuiDayRange} from '@taiga-ui/cdk';
import {BaseComponent} from 'compob2b-libs';
import {FormConfigService} from '../../../../../../../admin-shared/services/form-config.service';
import {DamFilterService} from '../../../../../dam-filter.service';

export interface DateFilters {
  start: null | Date;
  end: null | Date;
}

@Component({
  selector: 'app-sidebar-filters',
  templateUrl: './sidebar-filters.component.html',
  styleUrls: ['./sidebar-filters.component.scss']
})
export class SidebarFiltersComponent extends BaseComponent {
  @Input() fieldsFeatures: FormlyFieldConfig[];
  @Input() formFilter = new FormGroup({});
  @Input() options: FormlyFormOptions = {};
  @Input() modelFeatures: any = {};
  @Input() modelFeaturesFast: any = {};
  @Output() sidebarToggleEvent = new EventEmitter<boolean>();

  modelFeaturesArr: any = {};

  constructor(
    protected readonly formsConfig: FormConfigService,
    protected readonly route: ActivatedRoute,
    protected readonly damFilter: DamFilterService,
  ) {
    super();
  }

  filterSubmit(): void {
    console.log(this.formFilter.valid);
    // if (this.formFilter.valid) {
    // this.damFilter.event({event: 'filter', value: null});
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: this.convertModelFeatures(),
      queryParamsHandling: 'merge'
    });
    // }
  }

  private convertModelFeatures(): any {
    const retAll = [];

    console.log(this.modelFeatures);
    console.log(this.modelFeaturesArr);
    for (const [key, valueItem] of Object.entries(this.modelFeatures)) {

      if (typeof valueItem === 'object') {
        if (valueItem instanceof TuiDayRange) {
          this.modelFeaturesArr[key + '_from'] = valueItem.from.getFormattedDay('YMD', '-');
          this.modelFeaturesArr[key + '_to'] = valueItem.to.getFormattedDay('YMD', '-');
        }
        console.log(Array.isArray(valueItem));
        if (Array.isArray(valueItem)) {
          const ret = [];
          for (const [key2, value2] of Object.entries(valueItem)) {
            if (value2) {
              ret.push(value2);
              retAll.push(key2);
            }
          }

          if (ret.length > 0) {
            this.modelFeaturesArr[key] = ret.join(',');
          } else {
            delete this.modelFeaturesArr[key];
          }
        } else {

          this.modelFeaturesArr[key] = null;
          if (valueItem !== null && (valueItem['start'] !== undefined || valueItem['stop'] !== undefined)) {
            let urlValue = '';
            if (valueItem.hasOwnProperty('start') && valueItem['start'] !== null) {
              urlValue += valueItem['start'];
            }
            urlValue += ';';
            if (valueItem.hasOwnProperty('stop') && valueItem['stop'] !== null) {
              urlValue += valueItem['stop'];
            }
            if (urlValue !== ';') {
              this.modelFeaturesArr[key] = urlValue;
            }
          } else {
            delete this.modelFeaturesArr[key];
          }
          for (const key2 in valueItem) {
            if (valueItem.hasOwnProperty(key2) && key2 === 'value') {

              this.modelFeaturesArr[key] = valueItem[key2];
            }
          }

        }

      } else {
        if (valueItem !== undefined) {
          if ((this.damFilter.getYesNoFilterKeys().includes(key) && (valueItem === 'false' || valueItem === false))
            || valueItem !== 'false' && valueItem !== false && valueItem !== '' && valueItem !== '0' && valueItem !== 0) {
            this.modelFeaturesArr[key] = valueItem;
          } else {
            delete this.modelFeaturesArr[key];
          }
        }
      }
    }

    for (const [key, valueItem] of Object.entries(this.modelFeaturesFast)) {
      console.log(typeof valueItem);
      if (typeof valueItem === 'object') {
        console.log(Array.isArray(valueItem));
        if (Array.isArray(valueItem)) {
          const ret = [];
          for (const [key2, value2] of Object.entries(valueItem)) {
            if (value2) {
              ret.push(value2);
              retAll.push(key2);
            }
          }
          console.log(ret);
          console.log(ret.length);
          console.log(key);
          if (ret.length > 0) {
            this.modelFeaturesArr[key] = ret.join(',');
          } else {
            delete this.modelFeaturesArr[key];
          }
        } else {

          this.modelFeaturesArr[key] = null;
          if (valueItem !== null && (valueItem['start'] !== undefined || valueItem['stop'] !== undefined)) {
            let urlValue = '';
            if (valueItem.hasOwnProperty('start') && valueItem['start'] !== null) {
              urlValue += valueItem['start'];
            }
            urlValue += ';';
            if (valueItem.hasOwnProperty('stop') && valueItem['stop'] !== null) {
              urlValue += valueItem['stop'];
            }
            if (urlValue !== ';') {
              this.modelFeaturesArr[key] = urlValue;
            }
          } else {
            delete this.modelFeaturesArr[key];
          }
          const ret = [];
          for (const key2 in valueItem) {

            if (valueItem.hasOwnProperty(key2) && key2 === 'value') {
              this.modelFeaturesArr[key] = valueItem[key2];
            } else {
              ret.push(key2);
            }
          }
          if (ret.length > 0) {
            this.modelFeaturesArr[key] = ret.join(',');
          } else {
            delete this.modelFeaturesArr[key];
          }

        }

      } else {
        if (valueItem !== undefined) {
          if ((this.damFilter.getYesNoFilterKeys().includes(key) && (valueItem === 'false' || valueItem === false))
            || valueItem !== 'false' && valueItem !== false && valueItem !== '' && valueItem !== '0' && valueItem !== 0) {
            this.modelFeaturesArr[key] = valueItem;
          } else {
            delete this.modelFeaturesArr[key];
          }
        }
      }
    }

    if (this.route.snapshot.queryParamMap.get('catalog_id') != null && this.route.snapshot.queryParamMap.get('catalog_id')
      !== '0' && this.route.snapshot.queryParamMap.get('catalog_id') !== '') {
      this.modelFeaturesArr.catalog_id = this.route.snapshot.queryParamMap.get('catalog_id');
    } else {
      delete this.modelFeaturesArr.catalog_id;
    }

    if (this.route.snapshot.queryParamMap.get('keyword') !== undefined && this.route.snapshot.queryParamMap.get('keyword')
      !== '' && this.route.snapshot.queryParamMap.get('keyword') !== null) {
      this.modelFeaturesArr.keyword = this.route.snapshot.queryParamMap.get('keyword');
    } else {
      delete this.modelFeaturesArr.keyword;
    }
    return this.modelFeaturesArr;
  }

  protected readonly Object = Object;

  getTotalFiltered(): number {
    let isFiltered = 0;
    if (this.fieldsFeatures != undefined) {
      this.fieldsFeatures.forEach(item => {
        if (item.templateOptions.isFiltered) {
          isFiltered++;
        }
      });
    }
    return isFiltered;
  }

  filterSidebarFilter($event) {
    console.log($event.srcElement.value);
    if ($event.srcElement.value != '') {
      this.fieldsFeatures.forEach(item => {
        item.hideExpression = !item.templateOptions.label.toUpperCase().includes($event.srcElement.value.toUpperCase());
      });
    } else {
      this.fieldsFeatures.forEach(item => {
        item.hideExpression = false;
      });
    }
    this.cdr.detectChanges();
  }

  clearAll() {
    this.router.navigate(['cabinet', 'dam']);
  }

}
